<template>
  <div class="container">
    <img src="@/assets/logo_blue.png" class="logo" />
    <Form @submit="onBeforeSubmit" :validation-schema="validationSchema" class="form">
      <FormError :errors="globalErrors" />
      <div class="form-header">
        <span class="uk-text-bold uk-text-large">パスワードをお忘れの方</span>
      </div>
      <div class="field">
        <Field name="username" v-slot="{ field }">
          <FieldLabel title="ユーザーID" :required="true" />
          <input class="uk-input" type="text" v-bind="field" placeholder="ユーザーIDを入力してください" />
        </Field>
        <FieldError name="username" />
      </div>
      <div class="submit-button">
        <button type="button" class="uk-button" @click.stop="$router.go(-1)">
          戻る
        </button>
        <ActionButton title="認証コード送信" color="primary" type="submit" :disabled="processing" />
      </div>
    </Form>
  </div>
</template>
<style lang="scss" scoped>
.container {
  display: flex;
  height: 100vh !important;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
}
.form {
  width: 400px;
  form {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.submit-button {
  display: flex;
  justify-content: space-between;
}
.form-header {
  margin-bottom: $spacing-medium;
  margin-top: $spacing-ex-small;
}
.uk-button {
  border-radius: 5px;
  margin-top: $spacing-ex-medium;
  text-transform: none;
  width: 185px;
  color: #fff;
  background-color: $brand-color;
  &:hover,
  &:focus {
    background-color: $brand-deep-color;
    color: $link-color-active;
  }
}
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Field, Form } from "vee-validate";
import * as yup from "yup";
import { AuthApi } from "../../autogen";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ChangePassword from "../organisms/ChangePassword.vue";
import FormMixin from "../../helpers/mixins/form";
import ActionButton from "@/components/atoms/ActionButton.vue";
@Options({
  components: { Form, Field, FieldError, FormError, ChangePassword, ActionButton }
})
export default class ForgotPassword extends FormMixin {
  globalErrors: { message: string }[] = [];
  async onBeforeSubmit(values: { username: string }) {
    await this.onSubmit(async () => {
      await new AuthApi().forgotPassword({
        forgotPasswordRequest: { username: values.username }
      });
      this.$router.push({ name: "ResetPassword", params: { usernamea: values.username } });
    });
  }
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup.string().required(this.$t("input_required", { field: "ユーザーID" }))
    });
  }
}
</script>
